import React, { PureComponent } from "react";
import Window from "../Window";
import "./Insults.css";
import messages from "./messages";
import { navigate } from "@reach/router";

const TAIL_LENGTH = 25;
const tailLimit = 40;

const hasDeltaAbove = (a, b, diff = 0) => {
  return ["X", "Y"].some(
    dimension =>
      Math.abs(a[`screen${dimension}`] - b[`screen${dimension}`]) > diff
  );
};

class Insults extends PureComponent {
  state = {
    index: 0,
    windows: [],
    messages: [],
    latestWindow: {
      screenX: 0,
      screenY: 0
    },
    latestMouseEvent: {
      screenX: 0,
      screenY: 0
    }
  };

  componentDidMount() {
    this.setState(state => ({
      messages
    }));
    this._isMounted = true;
    this.enterFrame();
    document.addEventListener("mousemove", this.mouseMove, { passive: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isSafewordShouted && !prevProps.isSafewordShouted) {
      this.props.popScene(this.constructor);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("mousemove", this.mouseMove);
  }

  mouseMove = e => {
    this.setState({ latestMouseEvent: e });
  };

  enterFrame = () => {
    const { latestWindow, latestMouseEvent } = this.state;
    if (hasDeltaAbove(latestWindow, latestMouseEvent, 30)) {
      this.setState({
        latestWindow: latestMouseEvent
      });
      this.createWindow();
    }
    if (this._isMounted) {
      window.requestAnimationFrame(this.enterFrame);
    }
  };

  createWindow() {
    this.setState(state => ({
      windows: [
        ...Array.from({ length: state.windows.length - TAIL_LENGTH }),
        ...state.windows.slice(-TAIL_LENGTH),
        {
          key: state.windows.length,
          position: {
            x: state.latestWindow.screenX,
            y: state.latestWindow.screenY - 90
          },
          message: messages[Math.floor(messages.length * Math.random())]
        }
      ]
    }));
    if (this.state.windows.length > tailLimit) {
      navigate("/wall-of-shame");
    }
  }

  closeWindow(key) {
    this.setState(state => {
      const index = state.windows.findIndex(win => win.key === key);
      return {
        windows: [
          ...state.windows.slice(0, index),
          undefined,
          ...state.windows.slice(index + 1)
        ]
      };
    });
  }

  render() {
    const { windows } = this.state;
    return (
      <div className="Insults">
        {windows.filter(Boolean).map(({ message, position, key }) => (
          <Window
            key={key}
            draggable
            position={position}
            onClose={() => this.closeWindow(key)}
            confirm="Yes princess"
            getZIndex={this.props.getZIndex}
          >
            {message}
          </Window>
        ))}
      </div>
    );
  }
}

export default Insults;



// WEBPACK FOOTER //
// ./src/components/Insults/Insults.js